/**
 * Basemap tiles for every Leaflet map in the storefront — defined once, so changing provider is a
 * single edit rather than a hunt through the ordering feature.
 *
 * Provider is CARTO Voyager. We used it anonymously until CARTO stopped serving unkeyed requests
 * and began stamping "API KEY REQUIRED" diagonally across every tile; the free key below removes
 * the watermark. OpenStreetMap's own tile servers are not a home for a commercial product — that
 * is donated infrastructure with no stated allowance and no recourse if access is withdrawn.
 *
 * The key is public by necessity. The browser fetches tiles directly, so it is visible in the
 * shipped bundle and in devtools wherever we put it; secrecy is not the control. CARTO issue keys
 * per domain and watch the fair-use ceiling instead. Do not reuse it outside orderYaa.
 *
 * Free up to 5,000,000 tile requests per calendar month, counted across every orderYaa app and
 * across both the raster and vector services. Past that CARTO get in touch rather than cut access.
 *
 * Attribution is the price of the free tier and is contractual (Basemaps T&C §13): CARTO and
 * OpenStreetMap must both stay visible on every map. Do not strip it, and do not set
 * `attributionControl: false` on a map using these tiles.
 *
 * Worth knowing for later: CARTO have said raster is being retired in favour of vector tiles.
 * Vector needs MapLibre GL rather than Leaflet, so that is a genuine migration and not a URL
 * swap — but this same key already covers it when the time comes.
 */
export const MAP_TILE_URL =
  'https://basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png?key=cb1_2bxc_1_28e39e402c56127e7d44060c';

/** Passed straight through as the options argument to `L.tileLayer(MAP_TILE_URL, MAP_TILE_OPTIONS)`. */
export const MAP_TILE_OPTIONS = {
  attribution:
    '&copy; <a href="https://carto.com/attributions">CARTO</a>, ' +
    '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
  maxZoom: 19,
};
